import React, { useEffect, useState } from 'react';

import { Box, Modal, Backdrop, Fade, Button, Typography } from '@mui/material';

import { useBookingsContext } from '../../contexts/BookingsContext';
import { useBookingModalStyles } from './styles';
import SpotBooking from './SpotBooking';
import BookingDetails from './BookingDetails';
import BookingConfirmation from './BookingConfirmation';
import { useNavigate } from 'react-router-dom';

const BookingModal = () => {
  const navigate = useNavigate();
  const styles = useBookingModalStyles();
  const [width, setWidth] = useState<string>('');
  const [height, setHeight] = useState<string>('');

  const {
    isBookingModalOpen,
    setIsBookingModalOpen,
    bookingModalUrl,
    setBookingModalUrl,
    setEditBooking,
    setUserInfo,
    setSelectedPlan,
    refetchBookings,
  } = useBookingsContext();

  const clearModalData = () => {
    console.log('clearModalData...');
    setEditBooking(null);
    setUserInfo(null);
    setSelectedPlan(null);
  };

  const handleCloseBookingModal = async (redirect?: string | undefined) => {
    clearModalData();
    setBookingModalUrl('');
    setIsBookingModalOpen(false);
    await refetchBookings();
    if (redirect)
      setTimeout(() => {
        navigate(redirect);
      }, 300);
  };

  useEffect(() => {
    clearModalData();
    setWidth('');
    setHeight('');
  }, [isBookingModalOpen]);

  const componentMap = [
    {
      pattern: /^booking-spot$/,
      component: (
        <SpotBooking handleCloseBookingModal={handleCloseBookingModal} />
      ),
    },
    {
      pattern: /^booking-details/,
      component: (
        <BookingDetails handleCloseBookingModal={handleCloseBookingModal} />
      ),
    },
    {
      pattern: /^booking-confirmation/,
      component: (
        <BookingConfirmation
          handleCloseBookingModal={handleCloseBookingModal}
          setWidth={setWidth}
          setHeight={setHeight}
        />
      ),
    },
  ];

  const renderComponent = () => {
    for (const { pattern, component } of componentMap) {
      if (pattern.test(bookingModalUrl)) {
        return component;
      }
    }
    if (bookingModalUrl?.startsWith('http')) {
      return (
        <iframe
          src={bookingModalUrl}
          frameBorder="0"
          title="Content"
          width="100%"
          height="100%"></iframe>
      );
    }
    return null;
  };

  if (bookingModalUrl) console.log('::::bookingModalUrl', bookingModalUrl);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  if (!bookingModalUrl) return null;

  return (
    <>
      <Modal open={isConfirmOpen} onClose={() => setIsConfirmOpen(false)}>
        <Box sx={styles.confirmModal}>
          <Typography variant="h6" gutterBottom>
            Are you sure you want to cancel this booking?
          </Typography>
          <Box
            sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
            <Button onClick={() => setIsConfirmOpen(false)}>Cancel</Button>
            <Button
              color="error"
              variant="contained"
              onClick={() => {
                setIsConfirmOpen(false);
                handleCloseBookingModal();
              }}>
              Yes, Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={isBookingModalOpen && !!bookingModalUrl}
        onClose={() => {
          setIsConfirmOpen(true);
        }}
        closeAfterTransition
        //disableEscapeKeyDown
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 300,
          },
        }}>
        <Fade in={isBookingModalOpen}>
          <Box
            sx={{
              ...styles.modal,
              ...(width && { width }),
              ...(height && { minHeight: height, maxHeight: height }),
            }}>
            {renderComponent()}
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default BookingModal;
